import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-2.png'
import _imports_1 from '@/assets/bg_31.png'
import _imports_2 from '@/assets/bg_32.png'
import _imports_3 from '@/assets/bg_33.png'
import _imports_4 from '@/assets/bg_22.jpg'


const _withScopeId = n => (_pushScopeId("data-v-3a250828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "banner other" }
const _hoisted_3 = { class: "page_nav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))
const _hoisted_7 = { class: "banner" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_1
}, null, -1))
const _hoisted_9 = { class: "page_nav" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))
const _hoisted_13 = { class: "banner" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_2
}, null, -1))
const _hoisted_15 = { class: "page_nav" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))
const _hoisted_19 = { class: "banner" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_3
}, null, -1))
const _hoisted_21 = { class: "page_nav" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))
const _hoisted_25 = { class: "banner other" }
const _hoisted_26 = { class: "page_nav" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))
const _hoisted_30 = { class: "banner other" }
const _hoisted_31 = { class: "page_nav" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))
const _hoisted_35 = { class: "banner other" }
const _hoisted_36 = { class: "page_nav" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))
const _hoisted_40 = {
  class: "banner",
  id: "homeBanner"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_4
}, null, -1))
const _hoisted_42 = { class: "page_nav" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone iconfont icon-dianhuatianchong" }, "400-8039-718", -1))

import { ref, getCurrentInstance, onMounted, toRefs, watch, nextTick, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
// const emit = defineEmits(["updateScroll"]);

export default /*#__PURE__*/_defineComponent({
  props: {
  activeRoute: {
    type: String,
    default: "home",
  },
  scrollTurn: {
    type: Boolean,
    default: false,
  },
},
  emits: ["updateScroll"],
  setup(__props, { emit }: { emit: ({
  (e: "updateScroll", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const route = useRoute();
const router = useRouter();


let activeHeader = ref("home");
watch(
  () => props.activeRoute,
  (value) => {
    switch (value) {
      // case "home":
      case "scheme":
      case "flowPath":
      case "surveyDetails":
      case "apiServe":
      case "competitionAgree":
      case "aboutUs":
      case "other":
        activeHeader.value = value;
        break;

      default:
        activeHeader.value = "home";
        break;
    }
  },
  { immediate: true }
);
let list = [
  { title: "首页", type: 1, route: "home", path: "/home" },
  { title: "解决方案", type: 2, route: "scheme", path: "/scheme" },
  { title: "背调流程", type: 3, route: "flowPath", path: "/flowPath" },
  { title: "背调内容", type: 4, route: "surveyDetails", path: "/surveyDetails" },
  { title: "API服务", type: 5, route: "apiServe", path: "/apiServe" },
  { title: "竞业管理", type: 6, route: "competitionAgree", path: "/competitionAgree" },
  { title: "关于我们", type: 7, route: "aboutUs", path: "/aboutUs" },
];
// 路由跳转
const toRoute = (key) => {
  for (const i in list) {
    let item = list[i];
    if (key == item.type) {
      if (item.route == route.name) {
        return;
      }
      router.push(item.path);
      nextTick(() => {
        emit("updateScroll", "1");
      });
    }
  }
};
const toLogin = () => {
  let url=location.protocol+'//'+location.host+'/pc/index.html#/login'
  // location.href = "https://devyc.zecaimao.cn/pc/index.html#/login";
  location.href = url;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_6
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(activeHeader) == 'other']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_11))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_12
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(activeHeader) == 'flowPath']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_17))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_18
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(activeHeader) == 'competitionAgree']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_23))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_24
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(activeHeader) == 'aboutUs']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_28))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_29
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(activeHeader) == 'surveyDetails']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_33))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_34
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(activeHeader) == 'scheme']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_38))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_39
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(activeHeader) == 'apiServe']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_40, [
      _hoisted_41,
      _createElementVNode("div", {
        class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
      }, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
              onClick: ($event: any) => (toRoute(item.type))
            }, _toDisplayString(item.title), 11, _hoisted_44))
          }), 128))
        ]),
        _createElementVNode("div", { class: "link_nav" }, [
          _createElementVNode("div", {
            onClick: toLogin,
            class: "login"
          }, "登录"),
          _hoisted_45
        ])
      ], 2),
      _createElementVNode("div", {
        class: "exp_now",
        onClick: toLogin
      }, "立即体验")
    ], 512), [
      [_vShow, _unref(activeHeader)== 'home']
    ])
  ]))
}
}

})